import { trim } from 'ramda'
import { useSessionPermission } from '@btime/react-session'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistForm } from '../_form/ChecklistFormHandler'
import TemplateSection from './sections/TemplateSection'
import ReviewSection from './sections/ReviewSection'
import SegwareSection from './sections/SegwareSection'
import AutomaticDistributionSection from './sections/AutomaticDistributionSection'
import NameAndTypeSection from './sections/NameAndTypeSection'
import UsageSection from './sections/UsageSection'
import CheckInSection from './sections/CheckInSection'
import EmailSection from './sections/EmailSection'
import CalendarViewBgColorSection from './sections/CalendarViewBgColorSection'
import AllowBulkExecutionSection from './sections/AllowBulkExecutionSection'

export const useFieldsStepDef = () => {
  const { t } = useTranslation('editChecklist')
  const form = useChecklistForm()
  const requireChecklistType = useSessionPermission('requireChecklistType')

  return useMemo(
    () => ({
      title: 'fieldsStep.title',
      subtitle: 'fieldsStep.subtitle',
      Component: FieldsStep,
      validate: () => {
        if (!trim(form.name)) return [false, t('validationNameRequired')]
        if (form.usages.length <= 0) return [false, t('validationSelectUsage')]
        if (!form.type?.id && requireChecklistType) return [false, t('validationSelectType')]
        if (form?.configuration?.calendarView?.active && !form.configuration.calendarView?.backgroundColor)
          return [false, t('validationSelectCalendarColor')]
        return [true]
      }
    }),
    [form.name, form.usages, form.type, form.configuration, requireChecklistType, t]
  )
}

const FieldsStep = () => {
  return (
    <>
      <NameAndTypeSection />
      <TemplateSection />
      <UsageSection />
      <ReviewSection />
      <CheckInSection />
      <EmailSection />
      <AllowBulkExecutionSection />
      <CalendarViewBgColorSection />
      <AutomaticDistributionSection />
      <SegwareSection />
    </>
  )
}

export default FieldsStep
